import React, { useMemo } from "react";
import { AsyncPaginate } from "react-select-async-paginate";

const sanitizeValue = (val, isMulti) => {
    if (isMulti) {
        if (!Array.isArray(val)) return [];
        return val.filter(
            (v) =>
                v &&
                typeof v === "object" &&
                v.value !== undefined &&
                v.label !== undefined
        );
    } else {
        if (Array.isArray(val)) return val[0] || null;
        if (val && typeof val === "object" && val.value !== undefined) return val;
        return null;
    }
};

const ServiceSelect = ({
    value,
    onChange,
    loadServices,
    isMulti = false,
    placeholder = "Select Service",
    onAddService,
    cacheUniqs = []
}) => {
    const safeValue = useMemo(() => sanitizeValue(value, isMulti), [value, isMulti]);

    return (
        <AsyncPaginate
            isMulti={isMulti}
            value={safeValue}
            cacheUniqs={cacheUniqs}
            loadOptions={async (search, loadedOptions, additional) => {
                const res = await loadServices(search, loadedOptions, additional);
                let options = res?.options || [];

                // ➕ ADD SERVICE OPTION
                if (loadedOptions.length === 0 && !options.some(o => o.value === "__ADD_SERVICE__")) {
                    options.unshift({
                        value: "__ADD_SERVICE__",
                        label: "+ Add Service"
                    });
                }

                return {
                    ...res,
                    options
                };
            }}
            onChange={(val) => {
                const selected = sanitizeValue(val, isMulti);
                if (isMulti) {
                    if (selected?.some(v => v.value === "__ADD_SERVICE__")) {
                        if (onAddService) onAddService();
                        return;
                    }
                } else {
                    if (selected?.value === "__ADD_SERVICE__") {
                        if (onAddService) onAddService();
                        return;
                    }
                }
                onChange(selected);
            }}
            placeholder={placeholder}
            additional={{ page: 1 }}
            menuPortalTarget={document.body}
            styles={{
                menuPortal: base => ({ ...base, zIndex: 9999 }),
                control: (base) => ({
                    ...base,
                })
            }}
        />
    );
};

export default ServiceSelect;
